import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_QUALIFICATIONS_REQUEST: 'FETCH_QUALIFICATIONS_REQUEST',
    FETCH_QUALIFICATIONS_SUCCESS: 'FETCH_QUALIFICATIONS_SUCCESS',
    FETCH_QUALIFICATIONS_FAILURE: 'FETCH_QUALIFICATIONS_FAILURE',
    FETCH_QUALIFICATIONS_FILTRE_REQUEST: 'FETCH_QUALIFICATIONS_FILTRE_REQUEST',
    FETCH_QUALIFICATIONS_FILTRE_SUCCESS: 'FETCH_QUALIFICATIONS_FILTRE_SUCCESS',
    FETCH_QUALIFICATIONS_FILTRE_FAILURE: 'FETCH_QUALIFICATIONS_FILTRE_FAILURE'
};

/**
 * ActionCreator pour FETCH_QUALIFICATIONS_...
 * ActionCreator pour la récupération des qualifications
 */
const fetchQualificationsRequest = () => ({ type: Actions.FETCH_QUALIFICATIONS_REQUEST });
const fetchQualificationsSuccess = qualifications => ({ type: Actions.FETCH_QUALIFICATIONS_SUCCESS, qualifications });
const fetchQualificationsFailure = error => ({ type: Actions.FETCH_QUALIFICATIONS_FAILURE, error });

export const fetchQualifications = (force) => (dispatch, getState) => {
    if (getState().qualification.qualifications.isLoading) {
        return;
    }
    if (getState().qualification.qualifications.items.length > 0 && !force) {
        return;
    }
    return dispatch(_fetchQualifications());
};


const _fetchQualifications = () => async (dispatch) => {

    dispatch(fetchQualificationsRequest());

    try {
        let response = await axios.get('api/qualifications');

        dispatch(fetchQualificationsSuccess(response.data));

    } catch (error) {
        dispatch(fetchQualificationsFailure(error));
    }
};

/**
 * ActionCreator pour FETCH_QUALIFICATIONS_FILTRE...
 * ActionCreator pour la récupération des qualifications pour filtrer les réclamations
 */
const fetchQualificationsFiltreRequest = () => ({ type: Actions.FETCH_QUALIFICATIONS_FILTRE_REQUEST });
const fetchQualificationsFiltreSuccess = qualifications => ({ type: Actions.FETCH_QUALIFICATIONS_FILTRE_SUCCESS, qualifications });
const fetchQualificationsFiltreFailure = error => ({ type: Actions.FETCH_QUALIFICATIONS_FILTRE_FAILURE, error });

export const fetchQualificationsFiltre = (force) => (dispatch, getState) => {
    if (getState().qualification.qualificationsFiltre.isLoading) {
        return;
    }
    if (getState().qualification.qualificationsFiltre.items.length > 0 && !force) {
        return;
    }
    return dispatch(_fetchQualificationsFiltre());
};


const _fetchQualificationsFiltre = () => async (dispatch) => {

    dispatch(fetchQualificationsFiltreRequest());

    try {
        let response = await axios.get('api/qualifications/filtre');

        dispatch(fetchQualificationsFiltreSuccess(response.data));

    } catch (error) {
        dispatch(fetchQualificationsFiltreFailure(error));
    }
};
